import { createSelector } from 'reselect';
import get from 'lodash/get';
import { DateTime } from 'luxon';
import { State, SchedulesState, ScheduleDayInfo, ScheduleInfo } from 'types';
/**
 * This selector gets a practice schedule and transforms it into array of groups, where each group
 * is formed when several days in a row has the same start and end times.
 */

type Props = {
  practiceId: number;
};

const parse24to12hourTime = (time: string): string => {
  const luxonTime = DateTime.fromFormat(time, 'HH:mm');
  return luxonTime.toFormat(`h:mm'\u2009'a`);
};
const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const getScheduleForPractice = createSelector(
  (state: State, props: Props): string =>
    get(state, ['entities', 'practices', get(props, 'practiceId'), 'schedule']),
  (state: State): SchedulesState => get(state, ['entities', 'schedules']),
  (scheduleId, schedules) => {
    const schedule = get(schedules, scheduleId);
    if (!schedule) {
      return undefined;
    }
    if (!daysOfWeek.some((day) => Boolean(schedule[day]))) {
      return undefined;
    }
    return daysOfWeek.reduce((accum, day): ScheduleInfo => {
      const times: ScheduleDayInfo = schedule[day] as ScheduleDayInfo;

      if (times) {
        accum[day] = {
          endTime: parse24to12hourTime(times.endTime),
          startTime: parse24to12hourTime(times.startTime),
        };
      } else {
        accum[day] = null;
      }

      return accum;
    }, {} as ScheduleInfo);
  },
);
